export const UNSELECTED_OPTION_VALUE = "-1";

export const DEFAULT_COUNTRY_CODE = "US";

export const FALLBACK_COUNTRIES = [
  { value: 'US', label: 'United States', water_mark: 'Start typing any of state, county, city or zip ..'},
  { value: 'CA', label: 'Canada', water_mark: 'Start typing any of province, county, city or zip' },
  { value: 'GB', label: 'United Kingdom', water_mark: 'Start typing any of county, district, city or postal code' },
  { value: 'IN', label: 'India', water_mark: 'tart typing any of state, district, city or postal code' },
  { value: 'GR', label: 'Greece', water_mark: 'Start typing any of periphery, prefecture, city or zip' },
  { value: 'KE', label: 'Kenya', water_mark: 'Start typing any of Mkoa, Wilaya, Tarafa, Kata or locality' },
];